// vue-frontend/src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB41-rBKmG7mu6W7LAGIq-vWeQwweoC-Mk",
  authDomain: "lahautemaison-5a386.firebaseapp.com",
  projectId: "lahautemaison-5a386",
  storageBucket: "lahautemaison-5a386.firebasestorage.app",
  messagingSenderId: "980288454461",
  appId: "1:980288454461:web:cd639536e033c1aaee4f54"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
